import type { BridgeMessageHandler } from '../message-router.js';

export const handleSessionArchivedMessage: BridgeMessageHandler<'session_archived'> = (msg, deps) => {
  const sessionId = typeof msg.sessionId === 'string' ? msg.sessionId : '';
  if (!sessionId) return;
  void deps.sessionWorktreeManager.removeSessionWorktrees(sessionId);
};
